import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Project, Company, User } from 'api/models';
import { MeteorObservable } from 'meteor-rxjs';
import { AlertController, ModalController, NavParams, ActionSheetController } from 'ionic-angular';
import * as _ from 'lodash';
import { conformToMask } from 'angular2-text-mask'

import { AddProjectUserComponent } from '../add-project-user/add-project-user';
// import { getProject, getProjectMembers } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
// import { getCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import * as permissions from '../../services/permissions';
import { ISDEV } from '../../services/config';
import { AuthenticationService } from '../../services/congito';
import { HttpService } from '../../services/httpService';

@Component({
  selector: 'project-users',
  templateUrl: 'project-users.html'
})
export class ProjectUsers implements OnInit {
  projectMembers?: User[];
  showProfileMap: Object;
  project?: Project | void;
  company: Company | void;
  viewer: User;
  canAddUsers: boolean;
  canRemoveUsers: boolean;
  isProjectManager: boolean;
  isCompanyAdmin: boolean;
  isSuperAdmin: boolean;
  public isDev = ISDEV;

  constructor(
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    public navParams: NavParams,
    private actionSheetCtrl: ActionSheetController,
    public httpService: HttpService,
    public companyService: CompanyService,
    public projectService: ProjectService,
    public authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.showProfileMap = {};
  }

  ngOnInit(): void {
  if(this.isDev == true) { console.log('project users page') }
    const { projectId } = this.navParams.data;

    MeteorObservable.autorun().subscribe(() => {
      this.viewer = this.authenticationService.MeteorUser();
      const projectIdReactive = this.navParams.get('projectIdReactive');
      const projectId =  projectIdReactive && projectIdReactive.get();
      this.project = this.projectService.getProject(projectId);
      this.projectMembers = this.projectService.getProjectMembers(this.project);
      this.company = this.project ? this.companyService.getCompany(this.project.companyId) : null;
      this.updatePermissionParams();
    });
  }

  updatePermissionParams() {
    if (this.project && this.viewer && this.company) {
      this.isProjectManager = permissions.isProjectManager(this.project, this.viewer);
      this.isCompanyAdmin = permissions.isCompanyAdmin(this.company, this.viewer);
      this.isSuperAdmin = permissions.isSuperAdmin(this.viewer);
      this.canAddUsers =  this.isProjectManager || this.isCompanyAdmin || this.isSuperAdmin;
      this.canRemoveUsers = this.isProjectManager || this.isCompanyAdmin || this.isSuperAdmin;
    }
  }

  canMakeMemberProjectUpdater(member): boolean {
    if (!this.viewer || !this.project) {
      return false;
    }
    if (this.viewer._id === member._id) {
      // you can't demote yourself from PM to updater, but it's possible to make yourself an updater as the company admin/super admin?
      if (this.isProjectManager) {
        return false;
      }
      // you can't make yourself an updater if you're already an updater
      return !permissions.isProjectUpdater(this.project, member);
    }
    if (permissions.isProjectUpdater(this.project, member)) {
      return false;
    }
    return this.isProjectManager || this.isCompanyAdmin || this.isSuperAdmin;
  }

  canMakeMemberProjectManager(member): boolean {
    if (!this.project) {
      return false;
    }
    if (permissions.isProjectManager(this.project, member)) {
      return false;
    }
    return (this.isCompanyAdmin || this.isSuperAdmin);
  }

  toggleMemberProfile(member: User){
    this.showProfileMap[member._id] = !this.showProfileMap[member._id];
  }

  formatPhoneNumber(phoneNumberStr: void|string): string {
    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return conformToMask(phoneNumberStr || '', phoneMask, {guide:false}).conformedValue;
  }

  makeProjectManager(member: User, event): void {
    if (event) {
      event.stopPropagation();
    }
    const projectId = this.project && this.project._id;
    if (!projectId) {
     if(this.isDev == true) {  console.warn('Missing project') }
      return;
    }

    this.httpService.MeteorCall('makeProjectManager', projectId, member._id);
  }

  demotePm(member): void {
    const projectId = this.project && this.project._id;
    if (!projectId) {
     if(this.isDev == true) {  console.warn('Missing project') }
      return;
    }

    this.httpService.MeteorCall('demotePm', projectId, member._id);
  }

  removeProjectMember(member): void {
    const projectId = this.project && this.project._id;
    if (!projectId) {
      if(this.isDev == true) { console.warn('Missing project') }
      return;
    }

    let userId = member._id;

    const alert = this.alertCtrl.create({
      title: 'Confirm',
      message: `Are you sure you would like to remove this user from the Project?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            /*
            MeteorObservable.call('removeProjectMember', projectId, userId).subscribe({
              error: (e: Error) => {
                if (e) {
                  // this.handleError(e);
                }
              }
            });
            */
            this.httpService.MeteorCall('removeProjectMember', projectId, userId)
              .then(() => {})
              .catch((e: Error) => {
                if (e) {
                  // this.handleError(e);
                }
              });
            alert.dismiss();
            return false;
          }
        }
      ]
    });

    alert.present();
  }

  /** Does not include Cancel */
  getActionSheetItemsForUser(member: User) {
    const canMakeMemberPm = this.canMakeMemberProjectManager(member);
    const canMakeMemberUpdater = this.canMakeMemberProjectUpdater(member);
    const canRemoveUser = this.canRemoveUsers && this.viewer._id !== member._id;

    return _.compact([

      canMakeMemberPm && {
        text: 'Make PM',
        icon: 'star',
        handler: () => {
          this.makeProjectManager(member, event);
        }
      }, canMakeMemberUpdater && {
        text: 'Make Updater',
        icon: 'star-outline',
        handler: () => {
          this.demotePm(member);
        }
      }, canRemoveUser &&{
        text: 'Remove',
        icon: 'trash',
        handler: () => {
          this.removeProjectMember(member);
        }
      }
    ]);
  }

  canPresentActionSheetForUser(member: User): boolean {
    return this.getActionSheetItemsForUser(member).length > 0;
  }

  presentActionSheet(member: User, event) {
    if (event) {
      event.stopPropagation();
    }

    const actionSheet = this.actionSheetCtrl.create({
      title: '',
      buttons: [
        ...this.getActionSheetItemsForUser(member), {
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => { },
        },
      ],
    });
    actionSheet.present();
  }

  goToAddProjectUser(project): void {
    const modal = this.modalCtrl.create(AddProjectUserComponent, {"project": this.project}, {enableBackdropDismiss: false});
    modal.present();

  }
}



// WEBPACK FOOTER //
// ./src/pages/project-users/project-users.ts